import UslugaMapper from "~/cabinet/ts/data/usluga/Uslugi";
import {AccountStore, IInitialAppData} from "~/cabinet/ts/store/AccountStore";
import CabinetAnalyticCountersSenderInstance from "~/cabinet/ts/service/CabinetAnalyticCountersSender";

export default function setInitialAppData(initData: IInitialAppData) {
    initData.uslugi = initData.uslugi.filter(usluga => UslugaMapper.find(usluga.id));
    AccountStore.setInitialAppData(initData);
    CabinetAnalyticCountersSenderInstance.setUserParams(AccountStore.organization.value);
}